define("shared/components/shared/platform-notice", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="{{if @class @class}} cIC--card cIC--card__alt cIC--cardBorder" ...attributes>
    <div class="cIC--cardIcon">
      <span>
        {{#if @isAvailableOnDesktopAndMobile}}
          {{svg-jar
            "notification"
            class="o--icon o--icon--md o--icon--hl"
            data-test-platform-notice="desktop-and-mobile"
          }}
        {{else}}
          {{svg-jar "web" class="o--icon o--icon--md o--icon--hl" data-test-platform-notice="desktop"}}
        {{/if}}
      </span>
    </div>
    <div class="cIC--content u--m__l__xs">
      <h4 class="u--m__t__0 u--m__b__0">
        {{if @title @title (t "shared_phrases.desktop_notice.title")}}
      </h4>
      <p class="u--m__b__0 u--text--sm">
        {{if @body @body (t "shared_phrases.desktop_notice.subtitle")}}
      </p>
    </div>
  </div>
  */
  {
    "id": "luPHB/GC",
    "block": "[[[11,0],[16,0,[29,[[52,[30,1],[30,1]],\" cIC--card cIC--card__alt cIC--cardBorder\"]]],[17,2],[12],[1,\"\\n  \"],[10,0],[14,0,\"cIC--cardIcon\"],[12],[1,\"\\n    \"],[10,1],[12],[1,\"\\n\"],[41,[30,3],[[[1,\"        \"],[1,[28,[35,1],[\"notification\"],[[\"class\",\"data-test-platform-notice\"],[\"o--icon o--icon--md o--icon--hl\",\"desktop-and-mobile\"]]]],[1,\"\\n\"]],[]],[[[1,\"        \"],[1,[28,[35,1],[\"web\"],[[\"class\",\"data-test-platform-notice\"],[\"o--icon o--icon--md o--icon--hl\",\"desktop\"]]]],[1,\"\\n\"]],[]]],[1,\"    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,0],[14,0,\"cIC--content u--m__l__xs\"],[12],[1,\"\\n    \"],[10,\"h4\"],[14,0,\"u--m__t__0 u--m__b__0\"],[12],[1,\"\\n      \"],[1,[52,[30,4],[30,4],[28,[37,2],[\"shared_phrases.desktop_notice.title\"],null]]],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,2],[14,0,\"u--m__b__0 u--text--sm\"],[12],[1,\"\\n      \"],[1,[52,[30,5],[30,5],[28,[37,2],[\"shared_phrases.desktop_notice.subtitle\"],null]]],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[\"@class\",\"&attrs\",\"@isAvailableOnDesktopAndMobile\",\"@title\",\"@body\"],false,[\"if\",\"svg-jar\",\"t\"]]",
    "moduleName": "shared/components/shared/platform-notice.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});